"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _search = require("../utils/search");

var _constants = require("../constants");

var _results = require("@insided/destination/modules/Search/utils/results");

var _hitProcessing = require("@insided/destination/modules/Search/utils/hitProcessing");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function isCommunityResultTopic(el) {
  return el !== undefined && ('firstPost' in el || el.content_type === 'event');
}

var communityId = (0, _globals.default)('communityId');

var SearchService = /*#__PURE__*/function () {
  function SearchService() {
    (0, _classCallCheck2.default)(this, SearchService);
    (0, _defineProperty2.default)(this, "topicCache", {});
    (0, _defineProperty2.default)(this, "cancelToken", {});
    (0, _defineProperty2.default)(this, "tabFacets", []);
    (0, _defineProperty2.default)(this, "allResultsData", {
      results: []
    });
    (0, _defineProperty2.default)(this, "allResultsUpdateApplied", false);
  }

  (0, _createClass2.default)(SearchService, [{
    key: "fetchMetadataForTopics",
    value: function () {
      var _fetchMetadataForTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(topicsToFetch, loaderCallback, cancelTokenKey) {
        var _this$cancelToken$can,
            _this = this;

        var topicsToFetchFiltered, result, _result, topicIds, _iterator, _step, hit;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (_this$cancelToken$can = this.cancelToken[cancelTokenKey]) === null || _this$cancelToken$can === void 0 ? void 0 : _this$cancelToken$can.cancel(); // Filter out cached topics and events

                topicsToFetchFiltered = topicsToFetch.filter(function (topic) {
                  return !(topic.id in _this.topicCache) && !(0, _results.isCommunityResultEvent)(topic);
                });
                this.cancelToken[cancelTokenKey] = _axios.default.CancelToken.source();
                result = null;

                if (!topicsToFetchFiltered.length) {
                  _context.next = 23;
                  break;
                }

                _context.prev = 5;
                loaderCallback(true); // Use shared extractTopicIds utility for consistent ID extraction

                topicIds = (0, _hitProcessing.extractTopicIds)(topicsToFetchFiltered);
                _context.next = 10;
                return _axios.default.get('/search/getTopics', {
                  params: {
                    topicIds: topicIds
                  },
                  // Backend expects bracket notation: topicIds[]=1&topicIds[]=2
                  paramsSerializer: function paramsSerializer(p) {
                    return _qs.default.stringify(p, {
                      arrayFormat: 'brackets'
                    });
                  },
                  cancelToken: this.cancelToken[cancelTokenKey].token
                });

              case 10:
                result = _context.sent;
                loaderCallback(false);
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](5);

                _logger.logger.error(_context.t0, {
                  component: 'SearchService',
                  action: 'fetchMetadataForTopics'
                });

                loaderCallback(false);
                return _context.abrupt("return");

              case 19:
                if ((_result = result) !== null && _result !== void 0 && _result.data) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return");

              case 21:
                _iterator = _createForOfIteratorHelper(result.data);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    hit = _step.value;
                    this.topicCache[hit.id] = hit;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

              case 23:
                return _context.abrupt("return", topicsToFetch.map(function (topic) {
                  if ((0, _results.isCommunityResultEvent)(topic)) {
                    return topic;
                  }

                  var topicData = _this.topicCache[topic.id];

                  if (!topicData) {
                    return undefined;
                  } // Use shared utility for answer fallback pattern


                  // Use shared utility for answer fallback pattern
                  return (0, _hitProcessing.mergeAnswerFromHit)(topicData, topic);
                }).filter(isCommunityResultTopic));

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 14]]);
      }));

      function fetchMetadataForTopics(_x, _x2, _x3) {
        return _fetchMetadataForTopics.apply(this, arguments);
      }

      return fetchMetadataForTopics;
    }()
  }, {
    key: "getSectionsGroupedByContentType",
    value: function () {
      var _getSectionsGroupedByContentType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(fetchMetaData) {
        var _this2 = this;

        var topicsToFetch, sections;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(0, _isEqual.default)(this.allResultsData, {
                  results: []
                })) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                // I have allResultsData
                // I need to get metadata for each hit in allResultsData
                topicsToFetch = this.allResultsData.results.filter(function (item) {
                  return item.index === communityId;
                }).flatMap(function (result) {
                  return result.hits;
                });

                if (!fetchMetaData) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return this.fetchMetadataForTopics(topicsToFetch, function () {}, 'allResults');

              case 6:
                // I need to replace the hits in allResultsData with the metadata
                sections = [];
                this.allResultsData.results.forEach(function (item) {
                  var _item$facets$content_, _item$facets;

                  var contentType = Object.keys((_item$facets$content_ = (_item$facets = item.facets) === null || _item$facets === void 0 ? void 0 : _item$facets.content_type) !== null && _item$facets$content_ !== void 0 ? _item$facets$content_ : {})[0];

                  if (contentType) {
                    sections.push({
                      title: contentType,
                      hits: (fetchMetaData ? _this2.mapHitsToTopicInfo(item.hits) : item.hits).map(function (item) {
                        return _objectSpread(_objectSpread({}, item), {}, {
                          indexName: communityId
                        });
                      }),
                      type: 'content_type',
                      sourceType: 'community'
                    });
                  } else {
                    var _item$facets$source, _item$facets2, _item$facets$source2, _item$facets3;

                    sections.push({
                      title: Object.keys((_item$facets$source = (_item$facets2 = item.facets) === null || _item$facets2 === void 0 ? void 0 : _item$facets2.source) !== null && _item$facets$source !== void 0 ? _item$facets$source : {})[0],
                      // indexName is needed in AlgoliaSearch.tsx to track the source of the result
                      hits: item.hits.map(function (hit) {
                        return _objectSpread(_objectSpread({}, hit), {}, {
                          indexName: item.index
                        });
                      }),
                      type: 'source',
                      sourceType: Object.keys((_item$facets$source2 = (_item$facets3 = item.facets) === null || _item$facets3 === void 0 ? void 0 : _item$facets3.source) !== null && _item$facets$source2 !== void 0 ? _item$facets$source2 : {})[0]
                    });
                  }
                });
                return _context2.abrupt("return", (0, _search.sortArrayBySortOrder)({
                  data: sections,
                  key: 'title',
                  sortOrder: _constants.CONTENT_TYPE_SORT_ORDER
                }));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSectionsGroupedByContentType(_x4) {
        return _getSectionsGroupedByContentType.apply(this, arguments);
      }

      return getSectionsGroupedByContentType;
    }()
  }, {
    key: "mapHitsToTopicInfo",
    value: function mapHitsToTopicInfo(hits) {
      var _this3 = this;

      return hits.map(function (hit) {
        if ((0, _results.isCommunityResultEvent)(hit)) {
          return hit;
        }

        return _this3.topicCache[hit.id];
      }).filter(function (item) {
        return !!item;
      });
    }
  }, {
    key: "fetchResultsGroupedByContentTypeAndSources",
    value: function () {
      var _fetchResultsGroupedByContentTypeAndSources = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(requests, originalSearch, algoliSearchResponse, signal) {
        var newRequests, allResultsData;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newRequests = []; // Get the source facet object from all the indexes except community index
                // prepare requests to fetch data for each external source

                algoliSearchResponse.forEach(function (result, index) {
                  if (result.index === communityId) {
                    var _result$facets$conten, _result$facets;

                    var contentTypes = Object.keys((_result$facets$conten = (_result$facets = result.facets) === null || _result$facets === void 0 ? void 0 : _result$facets.content_type) !== null && _result$facets$conten !== void 0 ? _result$facets$conten : {});
                    contentTypes.forEach(function (contentType) {
                      newRequests.push({
                        indexName: requests[index].indexName,
                        query: requests[index].query,
                        params: _objectSpread(_objectSpread({}, requests[index].params), {}, {
                          facetFilters: ["content_type:".concat(contentType)],
                          hitsPerPage: 5
                        })
                      });
                    });
                  } else {
                    var _result$facets$source, _result$facets2;

                    var sources = Object.keys((_result$facets$source = (_result$facets2 = result.facets) === null || _result$facets2 === void 0 ? void 0 : _result$facets2.source) !== null && _result$facets$source !== void 0 ? _result$facets$source : {});
                    sources.forEach(function (source) {
                      newRequests.push({
                        indexName: requests[index].indexName,
                        query: requests[index].query,
                        params: _objectSpread(_objectSpread({}, requests[index].params), {}, {
                          facetFilters: ["source:".concat(source)],
                          hitsPerPage: 5
                        })
                      });
                    });
                  }
                });

                if (!(newRequests.length === 0)) {
                  _context3.next = 6;
                  break;
                }

                // console.log('%cNo new requests to fetch', 'font-weight: bold; color: red;')
                this.allResultsData = {
                  results: []
                };
                this.allResultsUpdateApplied = false;
                return _context3.abrupt("return");

              case 6:
                _context3.next = 8;
                return originalSearch(newRequests);

              case 8:
                allResultsData = _context3.sent;

                if (!(signal !== null && signal !== void 0 && signal.aborted)) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return");

              case 11:
                this.allResultsData = allResultsData;
                this.allResultsUpdateApplied = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchResultsGroupedByContentTypeAndSources(_x5, _x6, _x7, _x8) {
        return _fetchResultsGroupedByContentTypeAndSources.apply(this, arguments);
      }

      return fetchResultsGroupedByContentTypeAndSources;
    }()
  }]);
  return SearchService;
}();

var searchService = new SearchService();
var _default = searchService;
exports.default = _default;